import { IUserStatus, IUserStatusRaw } from 'models/user.model'

export const getUserStatusFromRawUserStatus = (
  userStatusRaw: IUserStatusRaw,
): IUserStatus => ({
  geoState: userStatusRaw.state || '',
  countryCode: userStatusRaw.country_code,
  isOnboardingSkipped: userStatusRaw.onboarding.is_skipped,
  onboarding: userStatusRaw.onboarding.quiz,
  config: {
    paymentCurrency: userStatusRaw.config?.payment_currency || '',
    paymentMethod: userStatusRaw.config?.payment_method || '',
    paymentId: userStatusRaw.config?.payment_id,
    isUserSignedUp: userStatusRaw.config?.is_user_signed_up || false,
    isUserDeclinedUpsell:
      userStatusRaw.config?.is_user_declined_upsell || false,
    isDiscountRevealApplied:
      userStatusRaw.config?.is_discount_reveal_applied || false,
    isDiscountApplied: userStatusRaw.config?.discount_applied || false,
    subscriptionPrice: userStatusRaw.config?.subscription_price || '',
    subscriptionDuration: userStatusRaw.config?.subscription_duration || '',
    priceId: userStatusRaw.config?.price_id || '',
    trialPeriod: userStatusRaw.config?.trial_period || '',
    trialPrice: userStatusRaw.config?.trial_price || '',
    screenName: userStatusRaw.config?.screen_name,
    periodQuantity: userStatusRaw.config?.period_quantity,
    periodName: userStatusRaw.config?.period_name,
    paymentSystem: userStatusRaw.config?.payment_system,
    cookieConsent: userStatusRaw.config?.cookie_consent,
    utmTags: userStatusRaw.config?.utm_tags,
    cancelOfferPreviousDiscount:
      userStatusRaw.config?.cancel_offer_previous_discount || 0,
    unvisitedUpsellPages: userStatusRaw.config?.unvisited_upsell_pages || [],
    processorName: userStatusRaw.config?.processor_name,
    stepsVariant: userStatusRaw.config?.steps_variant,
    timerEndTimes: userStatusRaw.config?.timer_end_times || {},
    targetUuid: userStatusRaw.config?.target_uuid,
    upiPurchaseData: userStatusRaw.config?.upi_purchase_data || null,
  },
  email: {
    hasEmail: userStatusRaw.email.has_email,
    hasEmailConsent: userStatusRaw.email.has_email_consent,
    isEmailConsentTried: userStatusRaw.email.is_email_consent_tried,
    onboardingEmail: userStatusRaw.email.onboarding_email,
  },
  hasSubscription: userStatusRaw.subscription.has_subscription,
  account: {
    hasAccount: userStatusRaw.account.has_account,
    email: userStatusRaw.account.identifier,
  },
  upsell: {
    isUpsellPurchased: userStatusRaw.upsell.is_upsell_purchased,
    isUpsellAvailable: userStatusRaw.upsell.is_upsell_available,
    isUpsellTried: userStatusRaw.upsell.is_upsell_tried,
  },
  inapp: {
    isInAppAvailable: userStatusRaw.inapp.is_inapp_available,
    isInAppPurchased: userStatusRaw.inapp.is_inapp_purchased,
    isInAppTried: userStatusRaw.inapp.is_inapp_tried,
  },
  upgrade: {
    isUpgradePassed: userStatusRaw.upgrade.is_upgrade_passed,
    isUpgradeAvailable: userStatusRaw.upgrade.is_upgrade_available,
  },
})
